export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const ADD_TAB = "ADD_TAB";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const CLOSE_TAB = "CLOSE_TAB";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SET_TOKEN = "SET_TOKEN";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const UPDATE_TAB = "UPDATE_TAB";
export const CLOSE_ALL_TABS = "CLOSE_ALL_TABS";
export const FACILITY_SWITCH_LOADING = "FACILITY_SWITCH_LOADING";


// SKU Table Actions
export const LOAD_TABLE = "LOAD_TABLE";

// Facility Actions
export const FETCH_FACILITIES_SUCCESS = "FETCH_FACILITIES_SUCCESS";
export const FETCH_FACILITIES_FAILURE = "FETCH_FACILITIES_FAILURE";
export const FETCH_FACILITIES_LOADING = "FETCH_FACILITIES_LOADING";
export const SET_SELECTED_FACILITY = "SET_SELECTED_FACILITY";